import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Starts a Stripe Checkout session for a fixed, server-side product and
 * redirects the browser to Stripe. Amounts are never sent from the client.
 */
const BuyButton = ({ lookupKey, children, className = "", testId, quantity = 1 }) => {
  const [loading, setLoading] = useState(false);

  const startCheckout = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/payments/checkout`, {
        lookup_key: lookupKey,
        quantity,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      const detail = e?.response?.data?.detail;
      toast.error(detail || "Checkout could not be started. Please try again.");
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={startCheckout}
      disabled={loading}
      data-testid={testId}
      className={`inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-lg font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sage focus:ring-offset-2 focus:ring-offset-cream disabled:opacity-60 ${className}`}
    >
      {loading && <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />}
      {children}
    </button>
  );
};

export default BuyButton;
